module.exports = __webpack_public_path__ + "img/video.bb016841.svg";